module.exports = __webpack_public_path__ + "static/media/font-size-w.7515d481.svg";